import EmployeeNav from "../components/user/employees/EmployeeNav";
import Title from "../utils/Title";
import AppWrapper from "./AppWrapper";

function BankingWrapper({ children, title }) {

  return (
    <>
      <AppWrapper
        pagename={"banking"}
      >
        <Title title={title} btnName={""} />
        {children}

        <EmployeeNav />

      </AppWrapper>

    </>
  );
}

export default BankingWrapper;
